import type { ChipProps } from "@mui/material"
import { Chip } from "@mui/material"
import { CloseFilledOutlined } from "@mui-symbols-material/w300"
import { type FC } from "react"

export const AerosTag: FC<ChipProps> = (props: ChipProps) => {
  const { disabled, sx, className, ...otherProps } = props

  return (
    <Chip
      variant='filled'
      size='small'
      className={className}
      sx={{
        cursor: "default",
        borderRadius: "0.125rem", // rounded-sm
        backgroundColor: disabled ? "#ebedf1" : "#e5e7eb",
        color: disabled ? "#9ca3af" : undefined,
        "&:hover": {
          backgroundColor: disabled ? "#ebedf1" : "#eceff1", // gray-300
        },
        "&:focus": {
          border: "1px solid #b2c7eb",
          boxShadow: "0 0 0 2px #bfdbfe",
        },
        "&.Mui-disabled": {
          opacity: 1,
        },
        "& .MuiChip-deleteIcon": {
          color: "rgba(0, 0, 0, 0.54)",
          "&:hover": {
            color: "rgba(0, 0, 0, 0.87)",
          },
        },
        ...sx,
      }}
      deleteIcon={<CloseFilledOutlined className='!h-4 !w-4' />}
      disabled={disabled}
      {...otherProps}
    />
  )
}
